import React, { useEffect, useState, useContext } from "react"
import { ApiGetCall, ApiGetCallAuthKey, ApiGetHeaders, ApiPostCall } from "../../JS/Connector";
import { CamelCaseWithSpaces, GetAllSchoolsByLocation, LogInUserID, formatDateToUsaMMDDYYYY, getTypeWatchDelay, getUrlParameter, isValidEmail, transformNameOfCol, typewatch } from "../../JS/Common";
import { MDBSwitch } from "mdb-react-ui-kit";
import AlertsComp from "../../Components/AlertsComp";
import { CheckValidation } from "../../Components/Validations";
import { Logout } from "../Signout";
import Pagination from "react-js-pagination";
import CustomizationPopup from "../../Components/CustomizationPopup";
import Deletepopup from "../../Components/Deletepopup";
import PageHead from "../../Components/PageHead";
import Popup from "../../Components/Popup";
import { hasRoleAccess, RoleEnum, RoleKey } from "../../JS/RoleType";
import useConfig from "../../Hooks/useConfig";
import { useStickyAction } from "../../Hooks";

export function Technician() {
    const { organizations, adminCallNode } = useConfig();
    const [isTechnicianPopup, setisTechnicianPopup] = useState(false);
    const [ValidEmail, setValidEmail] = useState("");
    const [allData, setAllData] = useState({
        firstname: "",
        lastname: "",
        access: "",
        email: "",
        flag: 1,
        Memberid: "",
        UserId: "",
        searchstring: '',
        sortByflag: 'desc',
        contactnum: '',
        extension: '',
        location: 0,
    });
    const [AccessDeviceForTech, setAccessDeviceForTech] = useState([]);
    const [Locations, setLocations] = useState([]);
    const [Users, setUsers] = useState([]);
    const [Alerts, setAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const showPagination = Users.length > 0;
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [columnNames, setColumnNames] = useState([]);
    const [deletePopup, setDeletePopup] = useState(false);
    const [Techid, setTechid] = useState('')
    const [SortKey, setSortKey] = useState(null)
    const [seeAllSchools, setSeeAllSchools] = useState(1);
    const [seeAllSchoolsCheckbox, setSeeAllSchoolsCheckbox] = useState(false);
    const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);

    useEffect(() => {
        ApiGetHeaders(33, setColumnNames)
    }, []);
    useEffect(() => {
        GetAccessDeviceForTech(allData.searchstring ? allData.searchstring : null, SortKey || null, false);
        GetAllSchoolsByLocation({ setLocations });

        if (getUrlParameter("flag") == "1") {
            setTimeout(function () {
                setAllData({ ...allData, access: RoleKey.K12_ADMIN });
            }, 500);
        }
    }, [currentPage, LimitForPagination]);
    async function GetAccessDeviceForTech(searchString, skey, toogleSort) {
        if (!searchString) searchString = null;
        if (skey && toogleSort) allData.sortByflag = allData.sortByflag == "asc" ? "desc" : "asc"
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`${adminCallNode}/users/all?search=${searchString}&sortBy=${skey}&sortByOrder=${allData.sortByflag}&page=${currentPage}&limit=${LimitForPagination}&userId=${LogInUserID}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs?.msg?.total)
                    setUsers(responseRs?.msg?.data?.length ? responseRs?.msg?.data : []);
                }
            });
        }, getTypeWatchDelay(searchString, 500));
    }
    async function GetAllAccessTypes(userid) {
        ApiGetCall(`${adminCallNode}/users/access-types?userId=${LogInUserID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setAccessDeviceForTech(responseRs);
            }
        });
    }

    async function DeactivateTech(Memberid, flag, Userid) {
        var loginuserid = LogInUserID;
        setLoading(true);
        var raw = JSON.stringify({
            k12UserId: Memberid,
            flag: flag,
        });
        await ApiPostCall(`${adminCallNode}/users/delete`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs?.status == "success") {
                    var msg = flag == 1 ? 'Technician Activated Successfully.' : 'Technician Deactivated Successfully.';
                    setAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                    if (loginuserid == Userid) {
                        Logout();
                    } else {
                        GetAccessDeviceForTech(null, null, false);
                        setTimeout(() => {
                            setAlerts(<AlertsComp show={false} />)
                        }, 2000);
                    }

                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        })
    }
    async function GetUserbyidForTech(itemid, userid) {
        setLoading(true);
        GetAllAccessTypes(userid);
        await ApiGetCall(`${adminCallNode}/users/data?uuid=${itemid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                setisTechnicianPopup(true);
                setSeeAllSchools(responseRs?.msg?.seeallschools);
                setAllData({
                    ...allData, firstname: responseRs?.msg.first_name, lastname: responseRs?.msg?.last_name,
                    email: responseRs?.msg?.email, access: responseRs?.msg?.accesstype?.role, flag: 2, Memberid: itemid,
                    contactnum: responseRs?.msg?.phone_number || null, extension: responseRs?.msg?.phone_number_ext || null,
                    location: responseRs?.msg?.location_id || 0
                });
                if (responseRs?.msg?.location_id) {
                    setSeeAllSchoolsCheckbox(true);
                }
            }
        });
    }
    async function SaveTechnician(flag) {
        var isFormValid = CheckValidation({ formID: 'UserForm' });
        if (allData.email != '') {
            if (!isValidEmail(allData.email)) {
                setValidEmail("Enter Valid Email");
                isFormValid = false;
            }
        }
        if (!isFormValid) return;
        const accessId = AccessDeviceForTech.find(a => a.role == allData.access)?.id || null;
        var raw = JSON.stringify({
            firstName: allData.firstname,
            lastName: allData.lastname,
            accessId,
            email: allData.email,
            uuid: flag == 1 ? 0 : allData.Memberid,
            locationId: allData.location || null,
            contactNumber: allData.contactnum || null,
            phoneNumberExt: allData.extension || null,
            seeAllSchools: seeAllSchools,
        });
        setLoading(true);
        await ApiPostCall(`${adminCallNode}/users/save`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs?.status == "success") {
                    setisTechnicianPopup(false);
                    var msg = allData.flag == 1 ? 'Technicians Added Successfully.' : 'Technicians Updated Successfully.';
                    setAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                    GetAccessDeviceForTech(allData.searchstring ? allData.searchstring : null, null, false);
                    setAllData({ ...allData, firstname: '', lastname: '', access: '', email: '', flag: 1, location: 0, contactnum: '', extension: '' });
                    ChangeAccess();
                    setValidEmail('');
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 2500);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs?.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 1000);
                }
            }
        });
    }
    function ChangeAccess() {
        setSeeAllSchools(1);
        let tempUser = Locations.map(item => item.name ? { ...item, isChecked: false } : item);
        setLocations(tempUser);
    }
    const handleSortClick = (item) => {
        if (item == "Access") {
            item = "access_type";
        }
        if (item !== 0) {
            GetAccessDeviceForTech(allData.searchstring, item, true)
        }
        setSortKey(item)
    };
    function renderContentForColumn(columnName, item) {
        const contentMap = {
            "Name": item.first_name + ' ' + item.last_name || '-',
            "Access": item.accessname || '-',
            "email": item.email || '-',
            "location": <div className="address">{item.location_name || '-'}</div>,
            "created_at": item?.created_at ? formatDateToUsaMMDDYYYY(item?.created_at) : '-',
        };
        return contentMap[columnName] || null;
    }
    async function DeleteTech() {
        setLoading(true);
        var raw = JSON.stringify({
            uuid: Techid
        });
        await ApiPostCall(`${adminCallNode}/technicians/delete`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setDeletePopup(false);
                if (result == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Technician Deleted Successfully"} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                        GetAccessDeviceForTech(allData.searchstring ? allData.searchstring : null, null, false);
                    }, 1500);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    function handleSearchChange(e) {
        setCurrentPage(1);
        GetAccessDeviceForTech(e.target.value, null, false);
        setAllData({ ...allData, searchstring: e.target.value });
    }
    const ModalBody = (
        <div className="row parent" id="UserForm">
            <div className='col-md-4 py-2'>
                <div className='FormLabel'>First Name<label className='redText'>*</label></div>
                <input type="text" name='firstname' autoComplete="off" className="form-control mt-2" required value={allData.firstname}
                    onChange={(e) => setAllData({ ...allData, firstname: e.target.value })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-md-4 py-2'>
                <div className='FormLabel'>Last Name<label className='redText'>*</label></div>
                <input type="text" name='firstname' autoComplete="off" className="form-control mt-2" required value={allData.lastname}
                    onChange={(e) => setAllData({ ...allData, lastname: e.target.value })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-md-4 py-2'>
                <div className='FormLabel'>Email<label className='redText'>*</label></div>
                <input type="email" name='Email' autoComplete="off" required className="form-control mt-2" value={allData.email}
                    onChange={(e) => setAllData({ ...allData, email: e.target.value })} />
                <span className="Emailinvalid">{ValidEmail}</span>
                <span className="form-text invalid-feedback"> *required</span>
            </div>
            <div className="col-md-4 py-2">
                <div className='FormLabel'>Access<label className='redText'>*</label></div>
                <select required className="mt-2" value={allData.access}
                    onChange={(e) => {
                        setAllData({ ...allData, access: e.target.value });
                        ChangeAccess();
                    }}>
                    <option value="0">Select </option>
                    {AccessDeviceForTech.map((item, i) => {
                        var returData;
                        returData = (
                            <option value={item.role} key={i} title={item.name} >{item.name} </option>
                        );
                        return returData;
                    })}
                </select>
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            {hasRoleAccess(
                AccessDeviceForTech.find(a => a.role == allData.access)?.role || null,
                RoleEnum.TECH_POINT_BOX
            ) ? (
                <>
                    <div className='col-md-4 py-2'>
                        <div className='FormLabel'>Location<label className='redText'>*</label></div>
                        <select required className="mt-2" value={allData.location}
                            onChange={(e) => {
                                setAllData({
                                    ...allData,
                                    location: e.target.value,
                                });
                                setSeeAllSchoolsCheckbox(true);
                            }}>
                            <option value="0">Select </option>
                            {Locations.map((item, i) => {
                                return <option value={item.id} key={i} >{item.location_name} </option>;
                            })}
                        </select>
                        <span className="form-text invalid-feedback">
                            *required
                        </span>
                    </div>
                    {seeAllSchoolsCheckbox &&
                        <div className="col-md-4 pb-2 pt-5">
                            <input type="checkbox" className="form-check-input me-2" name="seeallschools"
                                checked={seeAllSchools == 1} onChange={(e) => setSeeAllSchools(e.target.checked ? 1 : 0)} />
                            <b>See All {organizations}?</b>
                        </div>
                    }
                </>
            ) : null}
            {hasRoleAccess(
                AccessDeviceForTech.find(a => a.role == allData.access)?.role || null,
                RoleEnum.EXCLUDE_TECH
            ) ? (
                <>
                    <div className='col-md-3 pe-0 py-2'>
                        <div className='FormLabel'>Contact Number</div>
                        <input type="number" name='contactnumber' autoComplete="off" className="form-control mt-2" min={0}
                            value={allData.contactnum} onChange={(e) => setAllData({ ...allData, contactnum: e.target.value })}
                            onKeyDown={(e) => {
                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                    e.preventDefault();
                                }
                            }} />
                    </div>
                    <div className='col-md-1 ps-0 py-2'>
                        <div className='FormLabel'>Ext</div>
                        <input type="number" name='extension' autoComplete="off" className="form-control mt-2" min={0}
                            value={allData.extension} onChange={(e) => setAllData({ ...allData, extension: e.target.value })}
                            onKeyDown={(e) => {
                                if (["e", "E", "-", "."]?.includes(e?.key)) {
                                    e.preventDefault();
                                }
                            }} />
                    </div>
                </>
            ) : null}
        </div>
    );
    return (
        <React.Fragment>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Technicians"} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={true} />
            <div className="GridBox px-3 mt-2 py-2">
                <div className='row justify-content-end'>
                    <div className="col-md-3 my-2 text-end">
                        <label className='BorderBtn text-center marginDetailsPopup' title='Add Technician'
                            onClick={(e) => { GetAllAccessTypes(LogInUserID); ChangeAccess(); setisTechnicianPopup(true); setAllData({ ...allData, firstname: '', lastname: '', access: '', email: '', flag: 1, location: 0, contactnum: '' }); setSeeAllSchools(0); }}>
                            <img src='/images/AddInventory.svg' className='img-fluid pe-2' alt='Add Technician' />
                            Add Technician
                        </label>
                    </div>
                </div>
                <div className="greyBox p-3">
                    <div className="data-table-container" ref={tableWrapperRef}>
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>
                                    {columnNames?.map((item) => {
                                        const columnName = item.replace(/_/g, ' ');
                                        const transformedName = transformNameOfCol(columnName);
                                        if (!transformedName) return null;
                                        return (
                                            item != "location" && item != "created_at" ?
                                                <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={(e) => handleSortClick(item)}>
                                                    {CamelCaseWithSpaces(transformedName)}
                                                    <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                                </th>
                                                :
                                                <th key={item} scope="col" className='fw-600'>
                                                    {CamelCaseWithSpaces(transformedName)}
                                                </th>
                                        );
                                    })}
                                    <th scope="col" className='text-center fw-600'>Status </th>
                                    <th scope="col" className={`text-start fw-600 ${isOverflowing ? 'sticky-action' : ''}`}>Action
                                        <img src="/images/EditHeaderIcon.svg" className="cursor-pointer  img-fluid ps-2 pe-5" title='Customize Headers' style={{ height: '25px' }} onClick={(e) => setCustomizationModal(true)} />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {Users.length != 0 ? (
                                    Users?.map((item, i) => {
                                        return (
                                            <tr key={i} className={`OddEvenClass tableBorderHide ${item.flag}`}>
                                                {columnNames?.map(header => (
                                                    <td className="py-12" key={header}>
                                                        {renderContentForColumn(header, item)}
                                                    </td>
                                                ))}
                                                <td className="text-center py-12">
                                                    {(item.status == "1") ?
                                                        <MDBSwitch checked={item?.isChecked || true} className={`BgPink cursor-pointer ${item.status == "1" && item.can_edit_flag == 1 ? '' : 'opacity-25 cursor-context-menu'} `} onChange={(e) => { if (item.status == "1" && item.can_edit_flag == 1) return DeactivateTech(item.id, "2", item.userid) }} />
                                                        :
                                                        <MDBSwitch checked={item?.isChecked || false} className="BgPink cursor-pointer" onChange={(e) => { DeactivateTech(item.id, "1", item.userid) }} />
                                                    }
                                                </td>
                                                <td className={`text-start py-12 ${isOverflowing ? 'sticky-action' : ''}`}>
                                                    {(item.status == "1" && item.can_edit_flag == 1) ?
                                                        <img src="/images/EditIconNew.svg" title="Edit Technician" className="img-fluid cursor-pointer"
                                                            onClick={(e) => GetUserbyidForTech(item.id, item.userid)} techid={item.id} />
                                                        :
                                                        <img src="/images/DisableEditIcon.svg" className="img-fluid" techid={item.id} />
                                                    }
                                                    {item.access_type != 5 ? (
                                                        <img src="/images/DeleteIcon.svg" title="Delete Technician" style={{ height: "16px" }} className="img-fluid cursor-pointer px-2"
                                                            onClick={(e) => { setTechid(item.id); setDeletePopup(true) }} />
                                                    ) : (<></>)}
                                                </td>
                                            </tr>
                                        )
                                    }))
                                    :
                                    <tr className="text-center"><td colSpan={7}>No Record Found</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {showPagination && (
                    <Pagination
                        activePage={currentPage}
                        totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15}
                        itemsCountPerPage={LimitForPagination}
                        onChange={(e) => setCurrentPage(e)}
                        color="primary"
                        lastPageText=""
                        firstPageText=""
                        itemClassFirst="MasterClass"
                        itemClassPrev="MasterClass"
                        itemClassNext="MasterClass"
                        itemClassLast="MasterClass"
                        hideFirstLastPages={true} />
                )}
            </div>

            <Popup isshow={isTechnicianPopup} size={"lg"} title={allData.flag == 1 ? 'Add Technician' : 'Edit Technician'}
                closePopup={(e) => { setisTechnicianPopup(false); setAllData({ ...allData, firstname: '', lastname: '', access: '', email: '', flag: 1, location: 0, contactnum: '' }); ChangeAccess(); setValidEmail(''); }}
                modalBody={ModalBody} handleSave={(e) => allData.flag == 1 ? SaveTechnician(1) : SaveTechnician(2)} visibleSaveBtn={true} btnText={allData.flag == 1 ? 'Create Technician' : 'Update Technician'} />

            {CustomizationModal == true && (
                <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={'Technicians'} GetCall={() => ApiGetHeaders(33, setColumnNames)} />
            )}

            <Deletepopup text={`You won't be able to revert this!`} deletePopup={deletePopup} size="xl" deletePart={DeleteTech} DeleteShowClose={(e) => setDeletePopup(false)} />
        </React.Fragment>
    )
}
